var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.487,
    height: 12.093,
    viewBox: "0 0 19.487 12.093",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.549 -3.796)"
  }, /*#__PURE__*/React.createElement("line", {
    x2: 13.97,
    y2: 0.003,
    transform: "translate(6.065 9.886)",
    fill: "#777E91",
    stroke: "#777E91",
    strokeLinecap: "round",
    strokeWidth: "2px"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.046,0l6.046,7.774H0Z",
    transform: "translate(1.549 15.889) rotate(-90)",
    fill: "#777E91"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowLeft);
export default __webpack_public_path__ + "static/media/icon-arrow-left.dad5d0129ff6f6dc7e7dbe21a628f928.svg";
export { ForwardRef as ReactComponent };